module.exports = __webpack_public_path__ + "static/media/banner-bg.4f6368d7.png";